import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f90b876"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-top blue_header" }
const _hoisted_2 = { class: "main_title" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_w",
  src: "/assets/icon/btn_back_w.png",
  srcset: "/assets/icon/btn_back_w@2x.png 2x,/assets/icon/btn_back_w@3x.png 3x"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_6 = { class: "container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue_bg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "component_title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "조합지분 거래 사전신청"),
    /*#__PURE__*/_createTextVNode("하고"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "누구보다 먼저"),
    /*#__PURE__*/_createTextVNode(" 경험해보세요 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "component_info" }, [
    /*#__PURE__*/_createTextVNode(" 서비스 오픈전까지 사전신청하면"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 지분거래 수수료 30일 무료! ")
  ]),
  /*#__PURE__*/_createElementVNode("img", {
    class: "pre_app_img",
    src: "/assets/image/pre_application.png",
    srcset: "/assets/image/pre_application@2x.png 2x,/assets/image/pre_application@3x.png 3x"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "white_bg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "company_logos",
    src: "/assets/image/company_logos.png",
    srcset: "/assets/image/company_logos@2x.png 2x,/assets/image/company_logos@3x.png 3x"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "blue_info" }, " 3년 전에 배달의민족, 쿠팡 주식을 살 수 있었다면... 🤔 "),
  /*#__PURE__*/_createElementVNode("div", { class: "black_info" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "빠르게 성장"),
    /*#__PURE__*/_createTextVNode("하는 "),
    /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "스타트업의 가치"),
    /*#__PURE__*/_createTextVNode("는 상상 이상으로 높아집니다. 내가 사랑하는 서비스를 만드는 스타트업에 "),
    /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "10,000원"),
    /*#__PURE__*/_createTextVNode("부터 부담 없이 투자할 수 있는, "),
    /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "오직 엔젤리그에서만"),
    /*#__PURE__*/_createTextVNode(" 가능한 지분거래의 기회를 놓치지 마세요! ")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navy_bg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "navy_bg_title" }, " 조합지분 거래 Talk "),
  /*#__PURE__*/_createElementVNode("div", { class: "message_content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "sendMessage" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "right_message" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "message_style" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "조합지분"),
          /*#__PURE__*/_createTextVNode("이 뭔가요?")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "getMessage" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "left_message" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "message_style" }, [
          /*#__PURE__*/_createTextVNode(" 엔젤리그에서 클럽딜을 통해 설립된 [조합]은 스타트업의 주식을 보유하고 있고, [조합원]들은 각각 투자한 금액만큼 "),
          /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "[조합의 지분]"),
          /*#__PURE__*/_createTextVNode("을 가지고 있어요 🙂 "),
          /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "조합지분"),
          /*#__PURE__*/_createTextVNode("은 조합원 개인이 가지고 있는 지분을 말합니다. ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "sendMessage" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "right_message" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "message_style" }, " 아~ 조합원들은, 자신이 가진 조합지분을 자유롭게 팔 수 있는 건가요? ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "getMessage" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "left_message" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "message_style" }, [
          /*#__PURE__*/_createTextVNode(" 👍 설립된지 "),
          /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "1년이 지난 조합"),
          /*#__PURE__*/_createTextVNode("의 조합원은 엔젤리그 지분거래 기능을 사용해서 자신의 지분을 "),
          /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "원하는 가격에, 원하는 만큼"),
          /*#__PURE__*/_createTextVNode(" 팔 수 있어요. ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "sendMessage" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "right_message" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "message_style" }, " 조합지분을 사려면 어떻게 하나요? 누구나 살 수 있는 건가요? ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "getMessage" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "left_message" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "message_style" }, [
          /*#__PURE__*/_createTextVNode(" 기존 조합원이 판매 등록한 매물 중, 마음에 드는 조건의 지분을 바로 구매하거나, 조건을 협의해서 구매할 수 있어요 🙌"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" 엔젤리그의 안내를 따라 지분거래용 증권사 계정을 연동하신 사용자 누구나 조합지분 거래가 가능합니다. ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "sendMessage" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "right_message" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "message_style" }, " 조합지분을 사면 조합원이 되는 건가요? ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "getMessage" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "left_message" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "message_style" }, [
          /*#__PURE__*/_createTextVNode(" 네! 맞습니다. "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" 특정 조합지분을 구매하시면 그 조합의 조합원이 됩니다. ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "sendMessage" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "right_message" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "message_style" }, " 거래는 안전하게 이루어지나요? ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "getMessage" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "left_message" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "message_style" }, " 코리아에셋 투자증권의 중개로 거래 확정 및 결제가 안전하게 이루어지고, 엔젤리그가 조합지분 이전과 조합원 관리를 담당합니다. 😀 ")
      ])
    ])
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "white_bg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "white_margin" })
], -1))
const _hoisted_11 = { class: "container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue_bg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "spankle",
    src: "/assets/image/spankle.png",
    srcset: "/assets/image/spankle@2x.png 2x,/assets/image/spankle@3x.png 3x"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "apply_title" }, " 사전신청하기 ")
], -1))
const _hoisted_13 = { class: "white_bg" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "apply_info_title" }, " 나의 정보 확인 ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "apply_info_text main_16R" }, [
  /*#__PURE__*/_createTextVNode(" 안전하고 투명한 지분거래를 위해서 반드시"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "본인 명의의 은행/증권계좌, 주소 정보"),
  /*#__PURE__*/_createTextVNode("가 필요해요! "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 정보 입력 후 사전신청 승인이 완료됩니다 🙂 ")
], -1))
const _hoisted_16 = { class: "info_box" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, " 주소 ", -1))
const _hoisted_18 = { class: "row_bottom" }
const _hoisted_19 = {
  key: 0,
  class: "row_text"
}
const _hoisted_20 = {
  key: 1,
  class: "row_text mid-dark-gray"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn_open_g" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/btn_open_g.png",
    alt: "",
    srcset: "/assets/icon/btn_open_g@2x.png 2x,/assets/icon/btn_open_g@3x.png 3x"
  })
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, " 은행계좌 ", -1))
const _hoisted_23 = { class: "row_bottom" }
const _hoisted_24 = {
  key: 0,
  class: "row_text"
}
const _hoisted_25 = {
  key: 1,
  class: "row_text mid-dark-gray"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn_open_g" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/btn_open_g.png",
    alt: "",
    srcset: "/assets/icon/btn_open_g@2x.png 2x,/assets/icon/btn_open_g@3x.png 3x"
  })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, " 증권계좌 ", -1))
const _hoisted_28 = { class: "row_bottom" }
const _hoisted_29 = {
  key: 0,
  class: "row_text"
}
const _hoisted_30 = {
  key: 1,
  class: "row_text mid-dark-gray"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn_open_g" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/btn_open_g.png",
    alt: "",
    srcset: "/assets/icon/btn_open_g@2x.png 2x,/assets/icon/btn_open_g@3x.png 3x"
  })
], -1))
const _hoisted_32 = { class: "black_bg" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black_bg_title" }, " 초대코드 입력해주세요 ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mid-dark-gray main_16R" }, " 초대를 받으셨다면 입력해주세요 ", -1))
const _hoisted_35 = { class: "white_bg" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_16B" }, "확인", -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "container" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue_bg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "spankle",
    src: "/assets/image/spankle.png",
    srcset: "/assets/image/spankle@2x.png 2x,/assets/image/spankle@3x.png 3x"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "apply_title" }, " 사전신청 승인 완료 "),
  /*#__PURE__*/_createElementVNode("div", { class: "done_message" }, " 정보 확인이 완료되었습니다 ")
], -1))
const _hoisted_41 = { class: "white_bg" }
const _hoisted_42 = { class: "navy_box" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fees_info" }, " 나의 수수료 무료 기간 ", -1))
const _hoisted_44 = { class: "my_fees" }
const _hoisted_45 = { class: "friend_box" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "friend_img",
  src: "/assets/image/friend_pre_application.png",
  srcset: "/assets/image/friend_pre_application@2x.png 2x,/assets/image/friend_pre_application@3x.png 3x"
}, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "friend_content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "friend_info_title" }, [
    /*#__PURE__*/_createTextVNode(" 친구 1명만 사전신청 해도"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 수수료 60일 무료 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "friend_info_text" }, [
    /*#__PURE__*/_createTextVNode(" 누군가 내 초대코드 입력하고 사전신청하면,"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 수수료 무료기간이 60일로 늘어나요 ")
  ])
], -1))
const _hoisted_48 = { class: "friend_btns" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_16B" }, "공유 링크 복사", -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_16B" }, "초대코드 복사", -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  ref: "textDiv",
  class: "textDiv"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "blue_btn floating_btn btn_shadow" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title_16B" }, "사전 신청하기")
], -1))
const _hoisted_55 = [
  _hoisted_54
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_pre_app_info_box = _resolveComponent("pre-app-info-box")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        id: "preApp__ion_content",
        fullscreen: true,
        "scroll-events": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent btn-back",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
                }, [
                  _hoisted_4,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ])
              ])
            ])
          ]),
          _hoisted_5,
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _createVNode(_component_pre_app_info_box),
            _hoisted_10
          ], 512), [
            [_vShow, _ctx.curStatus === 'init']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "white_wrap",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.useSettingModal('address')))
                }, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.userInfo.address1 && _ctx.userInfo.address2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.userInfo.address1) + " " + _toDisplayString(_ctx.userInfo.address2), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, " 조합참여 계약을 위해 주소정보가 필요합니다. ")),
                    _hoisted_21
                  ])
                ]),
                _createElementVNode("div", {
                  class: "white_wrap",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.useSettingModal('account', 'refund')))
                }, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    (_ctx.userBankAccount.bankName && _ctx.userBankAccount.bankAccount)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.userBankAccount.bankName) + " " + _toDisplayString(_ctx.userBankAccount.bankAccount) + " " + _toDisplayString(_ctx.name), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, " 본인명의 은행계좌를 입력해주세요 ")),
                    _hoisted_26
                  ])
                ]),
                _createElementVNode("div", {
                  class: "white_wrap",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.useSettingModal('account', 'stock')))
                }, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    (_ctx.userStockBankAccount.stockBankName && _ctx.userStockBankAccount.stockBankAccount)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.userStockBankAccount.stockBankName) + " " + _toDisplayString(_ctx.userStockBankAccount.stockBankAccount) + " " + _toDisplayString(_ctx.name), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_30, " 본인명의 증권계좌를 입력해주세요 ")),
                    _hoisted_31
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _hoisted_34,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inviteCode) = $event)),
                type: "text",
                placeholder: "초대코드",
                class: "invite_code_input"
              }, null, 512), [
                [_vModelText, _ctx.inviteCode]
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("button", {
                class: "blue_btn",
                disabled: !_ctx.userInfo || !_ctx.userBankAccount || !_ctx.userStockBankAccount,
                onClickOnce: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.applyPreApplication && _ctx.applyPreApplication(...args)))
              }, _hoisted_38, 40, _hoisted_36)
            ]),
            _createVNode(_component_pre_app_info_box)
          ], 512), [
            [_vShow, _ctx.curStatus === 'apply']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.TotalFreeDay) + "일 🎉 ", 1)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("button", {
                    class: "blue_btn",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.copyText('https://angelleague.io/', 'link')))
                  }, _hoisted_50),
                  _createElementVNode("button", {
                    class: "purple_btn",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.copyText(_ctx.code, 'code')))
                  }, _hoisted_52)
                ]),
                _createElementVNode("div", _hoisted_53, null, 512)
              ])
            ])
          ], 512), [
            [_vShow, _ctx.curStatus === 'done']
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "fixed",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.user === null ? _ctx.$global.openLoginModal() : _ctx.nextProcess()))
          }, _hoisted_55, 512), [
            [_vShow, _ctx.curStatus === 'init']
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}